import http from "@/axios/http-common";
import CommonSuket, { EnSuketCategory } from "@/services/CommonSuket";
import type { SkmAutofill } from "@/types/suratKeteranganMedis";
import ErrorAlert from "@/utility/ErrorAlert";

const suket = new CommonSuket(EnSuketCategory.SuratKeteranganMedis);

/** Fakta klinis satu episode untuk prefill form. */
async function autofill(registerId: string | number): Promise<SkmAutofill> {
  const response = await http
    .getData(`/register/${registerId}/surat-keterangan-medis/autofill`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);

      return Promise.reject(err);
    });

  return response.data?.data;
}

/** TTD penanda tangan kedua (opsional) — slot ditentukan pembuat surat. */
async function signSecond(id: number, data: { password: string }) {
  const response = await http
    .postData(`/suket/surat-keterangan-medis/${id}/signature-2`, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);

      return Promise.reject(err);
    });

  return response.data;
}

/**
 * Cetak lewat jalur ber-token (`pdf-secure`), bukan route pdf publik: SKM
 * digerbangi privilege dan pembukanya dicatat. `responseType: "blob"` wajib —
 * tanpa itu axios mem-parse PDF sebagai teks dan berkasnya rusak senyap.
 */
async function print(id: number): Promise<void> {
  const tab = window.open("", "_blank");

  try {
    const response = await http.getDataParam(
      `/suket/surat-keterangan-medis/${id}/pdf-secure`,
      { responseType: "blob" }
    );

    const url = URL.createObjectURL(
      new Blob([response.data as BlobPart], { type: "application/pdf" })
    );

    if (tab) {
      tab.location.href = url;
    } else {
      window.open(url, "_blank");
    }

    setTimeout(() => URL.revokeObjectURL(url), 60000);
  } catch (err) {
    if (tab) {
      tab.close();
    }

    ErrorAlert.showErrorAlert(err);

    return Promise.reject(err);
  }
}

export default {
  create: (data) => suket.create(data),
  update: (id, data) => suket.update(id, data),
  getByRegister: (registerId: string | number) => suket.getByRegister(registerId),
  find: (id: number) => suket.find(id),
  destroy: (id: number) => suket.destroy(id),
  sign: (id: number, data) => suket.sign(id, data),
  autofill,
  signSecond,
  print
};
